export default __webpack_public_path__ + "static/media/950G.325a181b.jpg";